/**
 * Go Oil's booking pages move to Aperio (owner, 2026-10-27: "anyone trying to
 * go to the direct Go Oil booking page should just redirect to the Aperio
 * one ... not messing with any other tenants").
 *
 * Only the Go Oil tenant on its own host (gooil.app) is sent over, and only
 * the customer booking pages: the start page, every /book step and sign-up.
 * The path, query (?address=, ?promo=, utm_*) and hash go with it, so a link
 * to a step or an address lands on the same step at Aperio.
 *
 * Everything else stays on gooil.app: log in, password reset, the account
 * pages, the franchise / technician screens, the fleet dashboard, the shop
 * portal and service records. Staff and fleet logins do not carry over to
 * Aperio (auth/login-carry-over.ts), so moving them would lock them out. A
 * signed-in account with any role (staff, fleet, admin) is never sent over.
 */
export const APERIO_BOOKING_ORIGIN = 'https://book.aperiomobility.com';

/** The hosts that serve the Go Oil tenant's own booking portal. */
export const GO_OIL_BOOKING_HOSTS: readonly string[] = ['gooil.app', 'www.gooil.app'];

const MOVED_PATH = /^\/(?:book(?:\/.*)?|auth\/sign-up\/?)?$/;

export function goOilToAperioUrl(params: {
  subdomain?: string | null;
  host: string;
  pathname: string;
  search?: string;
  hash?: string;
  roles?: readonly string[] | null;
}): string | null {
  if (String(params.subdomain || '').toLowerCase() !== 'gooil') return null;
  if (!GO_OIL_BOOKING_HOSTS.includes(String(params.host || '').toLowerCase())) return null;
  if ((params.roles || []).some((r) => r && r !== 'customer')) return null;
  if (!MOVED_PATH.test(params.pathname || '/')) return null;
  return `${APERIO_BOOKING_ORIGIN}${params.pathname || '/'}${params.search || ''}${params.hash || ''}`;
}
